import { getStates, STATES_ENDPOINT } from '@src/service/states'
import useSWR from 'swr'

export const useStates = () => {
  return useSWR(STATES_ENDPOINT, getStates)
}
